export default __webpack_public_path__ + "static/media/select_game_friend.c27a119e.png";